import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import baseStyles from '../../base/outline-element/outline-element.base.css.lit';
import utilityStyles from '../../base/outline-element/outline-element.utilities.css.lit';
import baseHeadingStyles from '../../base/outline-heading/outline-heading.css.lit';
import headingStyles from '../idb-heading/idb-heading.css.lit';
import componentStyles from './idb-event-summary.css.lit';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';

/**
 * The IDB Styled Text component
 * @element idb-event-summary
 * @slot - default slot supplied by idb-styled-text
 */
@customElement('idb-event-summary')
export class IdbEventSummary extends OutlineElement {
  static styles: CSSResultGroup = [
    baseStyles, // Styles from outline-element. Primarily to include @tailwind base;
    utilityStyles, // Styles from outline-element. Primarily to include @tailwind utilities;
    baseHeadingStyles, // Styles from outline-heading.
    headingStyles, // Styles from idb-heading, a specific component we want to represent in the WYSIWYG.
    componentStyles, // Styles specific to idb-styled-text.
  ];

  render(): TemplateResult {
    return html`
    <section class="event-summary">
      <slot name="title"></slot>
      <slot name="summary"></slot>
    </section>

    </slot>`;
  }
}
